import '../styles/PageGlobal.css';
import './ProduitDetailsEditPage.css';
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ReferenceButton from '../components/ReferenceButton';
import { ProductService } from '../services/ProductService';

export default function ProduitDetailsEditPage() {
  const { product_id } = useParams();
  const navigate = useNavigate();

  const [form, setForm]       = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  // ── Data loader (Real Backend Call) ─────────────────────────────────────────
  const fetchProduit = useCallback(async () => {
    const produitService = new ProductService();
    setLoading(true);
    setError(null);
    try {
      const data = await produitService.getProductById(product_id);
      setForm(data);
    } catch (err) {
      console.error('Error fetching produit:', err);
      setError(err.message || 'Erreur lors du chargement du produit');
    } finally {
      setLoading(false);
    }
  }, [product_id]);

  useEffect(() => {
    fetchProduit();
  }, [fetchProduit]);

  // ── Field change handler ────────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  // ── Save handler (Real Backend Call) ────────────────────────────────────────
  const handleSave = async () => {
    const produitService = new ProductService();
    setLoading(true);
    setError(null);
    try {
      await produitService.updateProduct(product_id, form);
      alert('Produit mis à jour avec succès !');
      navigate('/product_list');
    } catch (err) {
      console.error('Error update produit:', err);
      setError(err.message || 'Erreur lors de la mise à jour');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/product_list');
  };

  // ── Render guards ───────────────────────────────────────────────────────────
  if (loading) return <div>Chargement…</div>;
  if (error)   return <div className="produit-edit-error">{error}</div>;
  if (!form || Object.keys(form).length === 0) return <div>Aucune donnée trouvée.</div>;

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <div className="containerMain produit-edit-container">
      <h1 className="produit-edit-title">Produit Détails / Edit</h1>
      <p>Ceci est un contenu protégé</p>

      <div className="produit-edit-form">

        {/* ── Part 1 ── */}
        <div className="produit-edit-section-title">Informations générales</div>

        <div className="produit-edit-row">
          <label>REF FABRICANT</label>
          <input name="refFabricant" value={form.refFabricant || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>REF INTERNE</label>
          <input name="refInterne" value={form.refInterne || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>DESIGNATION</label>
          <input name="designation" value={form.designation || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>DESCRIPTION</label>
          <textarea name="description" value={form.description || ''} onChange={handleChange} rows={3} />
        </div>
        <div className="produit-edit-row">
          <label>CAPACITE</label>
          <input name="capacite" value={form.capacite || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>TYPE DE PRODUIT</label>
          <input name="typeDeproduit" value={form.typeDeproduit || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>CATEGORIES</label>
          <input name="categories" value={form.categories || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>SOUS CATEGORIES</label>
          <input name="sousCategories" value={form.sousCategories || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>UNITE DE MESURE</label>
          <input name="uniteDeMesure" value={form.uniteDeMesure || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>PA</label>
          <input name="pa" value={form.pa || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>PV</label>
          <input name="pv" value={form.pv || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>ECOPARTICIPATION</label>
          <input name="ecoparticipation" value={form.ecoparticipation || ''} onChange={handleChange} />
        </div>

        {/* ── Part 2 ── */}
        <div className="produit-edit-section-title">Détails techniques</div>

        <div className="produit-edit-row">
          <label>DEEE</label>
          <input name="deee" value={form.deee || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>COUT DE REVIENT</label>
          <input name="coutDeRevient" value={form.coutDeRevient || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>EAN</label>
          <input name="ean" value={form.ean || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>HSCOD</label>
          <input name="hscod" value={form.hscod || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>PHOTOS</label>
          <input name="photos" value={form.photos || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>POIDS</label>
          <input name="poids" value={form.poids || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>LONGUEUR</label>
          <input name="longueur" value={form.longueur || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>LARGEUR</label>
          <input name="largeur" value={form.largeur || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>HAUTEUR</label>
          <input name="hauteur" value={form.hauteur || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>POIDS / VOLUME</label>
          <input name="poidsVolume" value={form.poidsVolume || ''} onChange={handleChange} />
        </div>
        <div className="produit-edit-row">
          <label>GARANTIE</label>
          <input name="garantie" value={form.garantie || ''} onChange={handleChange} />
        </div>

        {/* ── Actions ── */}
        <div className="produit-edit-actions">
          <ReferenceButton onClick={handleCancel}>Annuler</ReferenceButton>
          <ReferenceButton onClick={handleSave} style={{ opacity: loading ? 0.6 : 1 }}>
            {loading ? 'Enregistrement…' : 'Sauvegarder'}
          </ReferenceButton>
        </div>

      </div>
    </div>
  );
}